// firebaseConfig.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCMmjftZx9C5vsvRDtBZmdz4_NhW5dKS_k",
  authDomain: "trainchess.net",
  projectId: "train-chess",
  storageBucket: "train-chess.appspot.com",
  messagingSenderId: "110322528888",
  appId: "1:110322528888:web:6eb362e1cec32df208f38d",
  measurementId: "G-H6EVY1DCLX"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize individual Firebase services
const analytics = getAnalytics(app);
const db = getFirestore(app);  // Initialize Firestore
const functions = getFunctions(app); // Initialize Functions

// Export the initialized Firebase app and services
export { app, analytics, db, functions };
